import { ReactNode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MasterAuthProvider } from './context/MasterAuthContext';
import { RotaProtegida } from './components/RotaProtegida';
import { RotaProtegidaMaster } from './components/RotaProtegidaMaster';
import { CookieBanner } from './components/CookieBanner';
import { Login } from './pages/auth/Login';
import { Cadastro } from './pages/auth/Cadastro';
import { EsqueciSenha } from './pages/auth/EsqueciSenha';
import { RedefinirSenha } from './pages/auth/RedefinirSenha';
import { Home } from './pages/Home';
import { MateriaPrimaLista } from './pages/materia-prima/MateriaPrimaLista';
import { ProdutosLista } from './pages/produtos/ProdutosLista';
import { ProdutoForm } from './pages/produtos/ProdutoForm';
import { CardapioGestao } from './pages/cardapio/CardapioGestao';
import { CardapioPublico } from './pages/cardapio/CardapioPublico';
import { Kds } from './pages/kds/Kds';
import { EquipeLista } from './pages/equipe/EquipeLista';
import { FinanceiroLista } from './pages/financeiro/FinanceiroLista';
import { PedidosLista } from './pages/pedidos/PedidosLista';
import { RastreamentoMotoboys } from './pages/rastreamento/RastreamentoMotoboys';
import { LoginMotoboy } from './pages/rastreamento/LoginMotoboy';
import { PainelMotoboy } from './pages/rastreamento/PainelMotoboy';
import { RelatoriosLista } from './pages/relatorios/RelatoriosLista';
import { MasterLogin } from './pages/master/MasterLogin';
import { AdminUsuarios } from './pages/master/AdminUsuarios';
import { LandingPage } from './pages/landing/LandingPage';
import { PoliticaPrivacidade } from './pages/landing/PoliticaPrivacidade';
import { TermosDeUso } from './pages/landing/TermosDeUso';

function protegida(element: ReactNode) {
  return <RotaProtegida>{element}</RotaProtegida>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <MasterAuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />

            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/esqueci-senha" element={<EsqueciSenha />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/cardapio/:tenantId" element={<CardapioPublico />} />
            <Route path="/motoboy/:tenantId/login" element={<LoginMotoboy />} />
            <Route path="/motoboy/:tenantId/:token" element={<PainelMotoboy />} />

            <Route path="/painel" element={protegida(<Home />)} />
            <Route path="/pedidos" element={protegida(<PedidosLista />)} />
            <Route path="/materias-primas" element={protegida(<MateriaPrimaLista />)} />
            <Route path="/produtos" element={protegida(<ProdutosLista />)} />
            <Route path="/produtos/novo" element={protegida(<ProdutoForm />)} />
            <Route path="/produtos/:id/editar" element={protegida(<ProdutoForm />)} />
            <Route path="/cardapio" element={protegida(<CardapioGestao />)} />
            <Route path="/kds" element={protegida(<Kds />)} />
            <Route path="/equipe" element={protegida(<EquipeLista />)} />
            <Route path="/rastreamento" element={protegida(<RastreamentoMotoboys />)} />
            <Route path="/financeiro" element={protegida(<FinanceiroLista />)} />
            <Route path="/relatorios" element={protegida(<RelatoriosLista />)} />

            <Route path="/master/login" element={<MasterLogin />} />
            <Route
              path="/master"
              element={
                <RotaProtegidaMaster>
                  <AdminUsuarios />
                </RotaProtegidaMaster>
              }
            />
          </Routes>
          <CookieBanner />
        </MasterAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
